

import { useQuery } from "@tanstack/react-query";
import type { StoreSubscriptionCurrentScheduleView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseStoreSubscriptionCurrentScheduleQueryParams = {
  storeId: string;
};

export function useStoreSubscriptionCurrentScheduleQuery({
  storeId,
}: UseStoreSubscriptionCurrentScheduleQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.admin.storeSubscriptionCurrentSchedule(storeId),
    queryFn: () =>
      apiJsonClient<StoreSubscriptionCurrentScheduleView>(
        endpoints.admin.storeSubscriptionScheduleCurrent(storeId),
      ),
    enabled: storeId.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
